import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePageIndia/HomePage";
import DevelopersPage from "./TopDevelopersPageIndia/AllDevelper/TopDevelopersPage";
import SobhaDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Sobha/SobhaDeveloper";
import FourSDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/4S/4SDeveloper";
import M3MDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/M3M/M3MDeveloper";
import { FourSTheAurum } from "./ProjectPagesIndia/Gurugram/4s/The-Aurum/FourSTheAurum";
import BirlaDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Birla/BirlaDeveloper";
import ConscientDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Conscient/ConscientDeveloper";
import DlfDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/DLF/DlfDeveloper";
import EldecoDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Eldeco/EldecoDeveloper";
import MaxestateDeveloepr from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/MaxEstates/MaxestateDeveloper";
import SignatureGlobalDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/SignatureGlobal/SignatureGlobalDeveloper";
import SilvergladesDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Silverglades/SilvergladesDeveloper";
import SmartWorldDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/SmartWorld/SmartWorldDeveloper";
import TarcDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Tarc/TarcDeveloper";
import WhitelandDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/WhiteLand/WhitelandDeveloper";
import { M3MAltitude } from "./ProjectPagesIndia/Gurugram/m3m/m3m-altitude/M3mAltitude";
import { M3mMansion } from "./ProjectPagesIndia/Gurugram/m3m/m3m-mansion/M3mMansion";
import { M3MGolfHills } from "./ProjectPagesIndia/Gurugram/m3m/m3m-golfhills/M3mGolfHills";
import { M3mOpus } from "./ProjectPagesIndia/Gurugram/m3m/m3m-opus/M3mOpus";
import { M3MCrown } from "./ProjectPagesIndia/Gurugram/m3m/m3m-crown/M3mcrown";
import { M3mCapital } from "./ProjectPagesIndia/Gurugram/m3m/m3m-capital/M3mCapital";
import { M3MAntalya } from "./ProjectPagesIndia/Gurugram/m3m/m3m-antalya/M3mAntalya";
import { M3mMyDen } from "./ProjectPagesIndia/Gurugram/m3m/m3m-my-den/M3mMyDen";
import { DlfDahlias } from "./ProjectPagesIndia/Gurugram/dlf/dlf-dahlias/DlfDahlias";
import { DlfPrivanaWest } from "./ProjectPagesIndia/Gurugram/dlf/dlf-privana-west/DlfPrivanaWest";
import { DlfPrivanaSouth } from "./ProjectPagesIndia/Gurugram/dlf/dlf-privana-south/DlfPrivanaSouth";
import { DlfTheArbour } from "./ProjectPagesIndia/Gurugram/dlf/dlf-the-arbour/DlfTheArbour";
import { SmartWorldSkyArc } from "./ProjectPagesIndia/Gurugram/SmartWorld/SmartWorld-SkyArc/SmartWorldSkyArc";
import { SmartWorldOneDXP } from "./ProjectPagesIndia/Gurugram/SmartWorld/SmartWorld-One-DXP/SmartWorldOneDXP";
import { SmartWorldTheEdition } from "./ProjectPagesIndia/Gurugram/SmartWorld/SmartWorld-The-Edition/SmartWorldTheEdition";
import { WhiteLandUrbanResort } from "./ProjectPagesIndia/Gurugram/WhiteLand/WhiteLand-Urban-Resort/WhiteLandUrbanResort";
import { WhiteLandTheAspen } from "./ProjectPagesIndia/Gurugram/WhiteLand/WhiteLand-The-Aspen/WhiteLandTheAspen";
import { ConscientParq } from "./ProjectPagesIndia/Gurugram/Conscient/Conscient-Parq/ConscientParq";
import { MaxEstates360 } from "./ProjectPagesIndia/Gurugram/Max-Estates/Max-Estates-360/MaxEstates360";
import { SignatureGlobalTitanium } from "./ProjectPagesIndia/Gurugram/Signature-Global/Signature-Global-Titanium/SignatureGlobalTitanium";
import { SilvergladesLegacy } from "./ProjectPagesIndia/Gurugram/Silverglades/Silverglades-legacy/SilvergladesLegacy";
import { Silverglades59 } from "./ProjectPagesIndia/Gurugram/Silverglades/Silverglades-59/Silverglades59";
import { TarcIshva } from "./ProjectPagesIndia/Gurugram/Tarc/Tarc-Ishva/TarcIshva";
import { SobhaSector63 } from "./ProjectPagesIndia/Gurugram/Sobha/Sobha-Sector-63/SobhaSector63";
import { EldecoFairwayReserve } from "./ProjectPagesIndia/Gurugram/Eldeco/Eldeco-Fairway-Reserve/EldecoFairwayReserve";
import GurugramLocationPage from "./Location/Gurugram/GurugramLocationPage";
import SprRoad from "./Location/Gurugram/locations/SPR-Road/Spr-Road";
import GolfCourseRoad from "./Location/Gurugram/locations/Golf-Course-Road/Golf-Course-Road";
import GolfCourseExtensionRoad from "./Location/Gurugram/locations/Golf-Course-Extension-Road/Golf-Course-Extension-Road";
import DwarkaExpressway from "./Location/Gurugram/locations/Dwarika-Expressway/Dwarka-Expressway";
import LocationPage from "./Location/LocationPage";
import Trending_Projects from "./Trending-Projects/Trending_Projects";
import PuneLocationPage from "./Location/Pune/PuneLocationPage";
import WestPune from "./Location/Pune/locations/west-pune/WestPune";
import EastPune from "./Location/Pune/locations/east-pune/EastPune";
import CenterPune from "./Location/Pune/locations/center-pune/CenterPune";
import BangaluruLocationPage from "./Location/Bangaluru/BengaluruLocationPage";
import WestBengaluru from "./Location/Bangaluru/locations/west-bangaluru/WestBengaluru";
import BengaluruLocationPage from "./Location/Bangaluru/BengaluruLocationPage";
import MumbaiLocationPage from "./Location/Mumbai/MumbaiLocationPage";
import EastMumbai from "./Location/Mumbai/locations/east-mumbai/EastMumbai";
import NorthMumbai from "./Location/Mumbai/locations/north-mumbai/NorthMumbai";
import SouthMumbai from "./Location/Mumbai/locations/south-mumbai/SouthMumbai";
import Yashwantpuram from "./ProjectPagesIndia/Bangalore/Godrej/Yashwantpuram/Yashwantpuram";
import { LodhaDivino } from "./ProjectPagesIndia/Mumbai/Lodha/Divino/Divino";
import NewsUpdates from "./NewsUpdates/NewsUpdates";
import News_Update1 from "./NewsUpdates/All_News_Update/News_Update/News_Update1/News_Update1";
import News_Update2 from "./NewsUpdates/All_News_Update/News_Update/News_Update2/News_Update2";
import News_Update3 from "./NewsUpdates/All_News_Update/News_Update/News_Update3/News_Update3";
import CareerPage from "./CareersPage/CareerPage";
import Aboutus from "./AboutUs/Aboutus";
import ShapoorjiDeveloper from "./TopDevelopersPageIndia/Pune/shapoorji/ShapoorjiDeveloper";
import MahindraDevelopers from "./TopDevelopersPageIndia/Mumbai/Mahindra/MahindraDevelopers";
import GodrejDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Godrej/GodrejDeveloper";
import Andheri from "./ProjectPagesIndia/Mumbai/DLF/Andheri/Andheri";
import Birla from "./ProjectPagesIndia/Pune/Birla/Aditya-Birla-estates/Birla";
import NeoLiv from "./ProjectPagesIndia/Mumbai/Neo/LivAlibaug/NeoLiv";
import GeraDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Gera/GeraDeveloper";
import LodhaDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Lodha/LodhaDeveloper";
import NeoDeveloepr from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Neo/NeoDeveloper";
import MajestiqueDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Majestique/MajestiqueDeveloper";
import SaheelDeveloepr from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Saheel/SaheelDeveloepr";
import KolteDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Kolte/KolteDeveloper";
import KalpataruDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Kalpataru/KalpataruDeveloper";
import HiranandaniDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Hiranandani/HiranandaniDeveloper";
import EktaworldDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Ektaworld/EktaworldDeveloper";
import RustomjeeDeveloepr from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Rustomjee/RustomjeeDeveloepr";
import PuravankaraDeveloepr from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/puravankara/PuravankaraDeveloper";
import BrigadeDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Brigade/BrigadeDeveloper";
import SattvaDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/sattava/Sattvadeveloper";
import MantraDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Mantra/MantraDeveloper";
import MantriDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Mantri/MantriDeveloper";
import CasagrandDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Casagrand/CasagrandDeveloper";
import CGHSDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/CGHS/CGHSDeveloepr";
import { PurvankaraBlubelle } from "./ProjectPagesIndia/Bangalore/puravankara/blubelle/Blubelle";
import { PurvankaraMeraki } from "./ProjectPagesIndia/Bangalore/puravankara/meraki/PurvankaraMeraki";
import { PurvankaraZenium2 } from "./ProjectPagesIndia/Bangalore/puravankara/zenium2/PuravankaraZenium2";
import { PurvankaraParkHill } from "./ProjectPagesIndia/Bangalore/puravankara/parkhill/PurvankaraParkhill";
import { SaatvaForestRidge } from "./ProjectPagesIndia/Bangalore/sattva/forestridge/SattvaForestRidge";
import { SaatvaLumina } from "./ProjectPagesIndia/Bangalore/sattva/lumina/SaatvaLumina";
import { MantriBlossom } from "./ProjectPagesIndia/Bangalore/mantri/blossom/MantriBlossom";
import { MantriEnergia } from "./ProjectPagesIndia/Bangalore/mantri/energia/MantriEnergia";
import { BrigadeInsignia } from "./ProjectPagesIndia/Bangalore/brigade/insignia/BrigadeInsignia";
import { BrigadeHorizon } from "./ProjectPagesIndia/Bangalore/brigade/horizon/BrigadeHorizon";
import { EverGreenSquare } from "./ProjectPagesIndia/Pune/Godrej/Evergreen-Square/EverGreenSquare";
import { Vivant } from "./ProjectPagesIndia/Mumbai/kalpataru/vivant/Vivant";
import { KalpataruAzuro } from "./ProjectPagesIndia/Mumbai/kalpataru/azuro/Azuro";
import { KalpataruAdvay } from "./ProjectPagesIndia/Mumbai/kalpataru/advay/Advay";
import { HiranandaniVista } from "./ProjectPagesIndia/Mumbai/Hiranandani/Vista/Vista";
import { HiranandaniRegentHill } from "./ProjectPagesIndia/Mumbai/Hiranandani/Regenthill/RegentHill";
import { EktaEden62 } from "./ProjectPagesIndia/Mumbai/Ekta/Eden62/Eden62";
import { EktaParksville } from "./ProjectPagesIndia/Mumbai/Ekta/Parksville/Parksville";
import { RustomjeeParishram } from "./ProjectPagesIndia/Mumbai/Rustomjee/Parishram/Parishram";
import { RustomjeeBayView } from "./ProjectPagesIndia/Mumbai/Rustomjee/Bayview180/Bayview180";
import { RustomjeePanorama } from "./ProjectPagesIndia/Mumbai/Rustomjee/Panorama/Panorama";
import { GodrejSkygreen } from "./ProjectPagesIndia/Pune/Godrej/skygreen/GodrejSkygreen";
import { IslandOfJoy } from "./ProjectPagesIndia/Pune/Gera/IslandOfJoy/IslandOfJoy";
import { KolteCanvas } from "./ProjectPagesIndia/Pune/Kolte/Canvas/Canvas";
import { LodhaGiardino } from "./ProjectPagesIndia/Pune/Lodha/Giardino/Giardino";
import { ShapoorjiGolfland } from "./ProjectPagesIndia/Pune/Shapoorji/vanaha/Golfland";
import { ShapoorjiWildernest } from "./ProjectPagesIndia/Pune/Shapoorji/Wildernest/Wildernest";
import { MantraOneResidences } from "./ProjectPagesIndia/Pune/Mantra/OneResidences/OneResidences";
import { SobhaAltus } from "./ProjectPagesIndia/Gurugram/Sobha/SobhaAltus/SobhaAltus";
import { SobhaCity } from "./ProjectPagesIndia/Gurugram/Sobha/SobhaCity/SobhaCity";
import { SaheelTrendyWest } from "./ProjectPagesIndia/Pune/sahell/trendywest/SaheelTrendyWest";
import TrinityDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/Trinity/TrinityDeveloper";
import { TrinityPlazzos } from "./ProjectPagesIndia/Gurugram/Trinity/Palazzos/TrinityPlazzos";
import { BirlaArika } from "./ProjectPagesIndia/Gurugram/Birla/Birla-Arika/BirlaArika";
import { JoyOfTreetops } from "./ProjectPagesIndia/Pune/Gera/JoyOfTreetops/JoyOfTreetops";
import { Table } from "./components/leads/Table";
import Mahindralifespaces from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/mahindralifespaces/Mahindralifespaces";
import { RiverCrest } from "./ProjectPagesIndia/Pune/Godrej/river-crest/RiverCrest";
import { Skyline } from "./ProjectPagesIndia/Pune/Godrej/skyline/Skyline";
import { Riverroyale } from "./ProjectPagesIndia/Pune/Godrej/riverroyale/Riverroyale";
import { Thetrillion } from "./ProjectPagesIndia/Gurugram/experion/thetrillion/Thetrillion";
import Experiondeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/experion/Experiondeveloper";
import Blog from "./NewsUpdates/All_News_Update/News_Update/18-04-25/Blog";
import Blog210425 from "./NewsUpdates/All_News_Update/News_Update/21-04-25/Blog210425";
import Blog240425 from "./NewsUpdates/All_News_Update/News_Update/24-04-25/Blog240425";
import { Serio } from "./ProjectPagesIndia/Pune/ganga/Serio";
import Gangadeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/ganga/Gangadeveloper";
import { Joyvillesensorium } from "./ProjectPagesIndia/Pune/Shapoorji/joyvillesensorium/Joyvillesensorium";
import { Emeraldcascadia } from "./ProjectPagesIndia/Bangalore/tvs/emeraldcascadia/Emeraldcascadia";
import TvsDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/tvs/TvsDeveloper";
import { Isleoftrees } from "./ProjectPagesIndia/Bangalore/tvs/isleoftrees/Isleoftrees";
import { Hosaroad } from "./ProjectPagesIndia/Bangalore/lodha/hosaroad/Hosaroad";
import { Pashmina } from "./ProjectPagesIndia/Bangalore/brigade/pashmina/Pashmina";
import { Whitefield } from "./ProjectPagesIndia/Bangalore/embassy/whitefield/Whitefield";
import Embassydeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/embassy/Embassydeveloper";
import { Platinum } from "./ProjectPagesIndia/Pune/ganga/platinum/Platinum";
import { Jadeskyline } from "./ProjectPagesIndia/Pune/kalpataru/jade-skyline/Jadeskyline";
import BlogList from "./NewsUpdates/blogs/BlogList";
import BlogDetailTwo from "./components/body/blogpagecomponents/Blogdetails";
import { Shubhnirvana } from "./ProjectPagesIndia/Pune/shubh/nirvana/Shubhnirvana";
import ShubhDeveloper from "./TopDevelopersPageIndia/AllDevelper/DevelopersPage/shubh/ShubhDeveloper";
import { Uniquekville } from "./ProjectPagesIndia/Pune/unique/kville/Uniquekville";
import { Saroha } from "./ProjectPagesIndia/Pune/rohan/saroha/Saroha";
import { Skycity } from "./ProjectPagesIndia/Pune/bramha/skycity/Skycity";
import { Evoque } from "./ProjectPagesIndia/Pune/nyati/evoque/Evoque";
import { Emeraldwaters } from "./ProjectPagesIndia/Pune/Godrej/emerald-waters/Emeraldwaters";
import { Grande } from "./ProjectPagesIndia/Pune/vilasjavdekar/grande/Grande";
import { Panache } from "./ProjectPagesIndia/Pune/Lodha/panache/Panache";
import { TheDualis } from "./ProjectPagesIndia/Gurugram/shapoorji-pallonji/the-dualis/Thedualis";
import { Nidita } from "./ProjectPagesIndia/Pune/rohan/nidita/Nidita";
import { Privananorth } from "./ProjectPagesIndia/Gurugram/dlf/privananorth/Privananorth";
import { Magnus } from "./ProjectPagesIndia/Pune/Lodha/magnus/Magnus";
import { Eonhomes } from "./ProjectPagesIndia/Pune/kasturi/eonhomes/Eonhomes";
import { Monarque } from "./ProjectPagesIndia/Pune/vtp/monarque/Monarque";
import { Parktitan } from "./ProjectPagesIndia/Pune/pridepurple/Parktitan";
import { Sunway } from "./ProjectPagesIndia/Pune/megapolis/Sunway";
import { Itrendhomes } from "./ProjectPagesIndia/Pune/saheel/Itrendhomes";
import { Ridges41 } from "./ProjectPagesIndia/Pune/paranjape/Ridges41";
import { Aston } from "./ProjectPagesIndia/Pune/rahul/Aston";

function App() {
  return (
    <Router>
      <Routes>
        {/* Tab*/}
        <Route path="*" element={<HomePage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/leads9292" element={<Table />} />
        <Route path="/developer" element={<DevelopersPage />} />
        <Route path="/cities" element={<LocationPage />} />
        <Route path="/trending-projects" element={<Trending_Projects />} />
        <Route path="/gurugram" element={<GurugramLocationPage />} />
        <Route path="/pune" element={<PuneLocationPage />} />
        <Route path="/mumbai" element={<MumbaiLocationPage />} />
        <Route path="/bengaluru" element={<BengaluruLocationPage />} />
        <Route path="/news-updates" element={<NewsUpdates />} />
        <Route path="/careers" element={<CareerPage />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/demo" element={<FourSTheAurum />} />

        {/* Developers  Gurugram*/}
        <Route path="/developers/4s" element={<FourSDeveloper />} />
        <Route path="/developers/m3m" element={<M3MDeveloper />} />
        <Route path="/developers/conscient" element={<ConscientDeveloper />} />
        <Route path="/developers/eldeco" element={<EldecoDeveloper />} />
        <Route
          path="/developers/max-estates"
          element={<MaxestateDeveloepr />}
        />
        <Route
          path="/developers/signature-global"
          element={<SignatureGlobalDeveloper />}
        />
        <Route
          path="/developers/silverglades"
          element={<SilvergladesDeveloper />}
        />
        <Route
          path="/developers/smartworld"
          element={<SmartWorldDeveloper />}
        />
        <Route path="/developers/sobha" element={<SobhaDeveloper />} />
        <Route path="/developers/tarc" element={<TarcDeveloper />} />
        <Route path="/developers/whiteland" element={<WhitelandDeveloper />} />
        <Route path="/developers/dlf" element={<DlfDeveloper />} />
        <Route path="/developers/trinity" element={<TrinityDeveloper />} />
        <Route path="/developers/birla" element={<BirlaDeveloper />} />
        <Route path="/developers/experion" element={<Experiondeveloper />} />
        {/* Developer Pune */}
        <Route path="/developers/gera" element={<GeraDeveloper />} />
        <Route path="/developers/lodha" element={<LodhaDeveloper />} />
        <Route path="/developers/mantra" element={<MantraDeveloper />} />
        <Route
          path="/developers/majestique"
          element={<MajestiqueDeveloper />}
        />
        <Route path="/developers/saheel" element={<SaheelDeveloepr />} />
        <Route path="/developers/kolte" element={<KolteDeveloper />} />
        <Route path="/developers/godrej" element={<GodrejDeveloper />} />
        <Route
          path="/developers/shapoorji-pallonji"
          element={<ShapoorjiDeveloper />}
        />
        <Route path="/developers/ganga" element={<Gangadeveloper />} />
        <Route path="/developers/shubh" element={<ShubhDeveloper />} />

        {/* Developer Mumbai */}
        <Route path="/developers/neo" element={<NeoDeveloepr />} />
        <Route path="/developers/kalpataru" element={<KalpataruDeveloper />} />
        <Route
          path="/developers/hiranandani"
          element={<HiranandaniDeveloper />}
        />
        <Route path="/developers/ektaworld" element={<EktaworldDeveloper />} />
        <Route path="/developers/rustomjee" element={<RustomjeeDeveloepr />} />
        <Route
          path="/developers/mahindra-lifespaces"
          element={<Mahindralifespaces />}
        />
        {/* Develoeper Bengaluru */}
        <Route
          path="/developers/puravankara"
          element={<PuravankaraDeveloepr />}
        />
        <Route path="/developers/brigade" element={<BrigadeDeveloper />} />
        <Route path="/developers/sattva" element={<SattvaDeveloper />} />
        <Route path="/developers/mantri" element={<MantriDeveloper />} />
        <Route path="/developers/casagrand" element={<CasagrandDeveloper />} />
        {/* <Route path="/developers/cghs" element={<CGHSDeveloper />} /> */}

        <Route path="/developers/tvs" element={<TvsDeveloper />} />
        <Route path="/developers/embassy" element={<Embassydeveloper />} />

        {/*  Projects Gurugram */}
        <Route
          path="/m3m-altitude-sector-65-gurugram"
          element={<M3MAltitude />}
        />
        <Route
          path="/m3m-mansions-sector-113-gurugram"
          element={<M3mMansion />}
        />
        <Route
          path="/m3m-golf-hills-sector-79-gurugram"
          element={<M3MGolfHills />}
        />
        <Route path="/m3m-crown-sector-111-gurugram" element={<M3MCrown />} />
        <Route
          path="/m3m-antalya-hills-sector-79-gurugram"
          element={<M3MAntalya />}
        />

        <Route
          path="/signature-global-titanium-spr-sector-71-gurugram"
          element={<SignatureGlobalTitanium />}
        />

        <Route
          path="/smartworld-edition-sector-66-gurugram"
          element={<SmartWorldTheEdition />}
        />
        <Route
          path="/smartworld-one-dxp-sector113-gurugram"
          element={<SmartWorldOneDXP />}
        />
        <Route
          path="/smartworld-skyarc-sector-69-gurugram"
          element={<SmartWorldSkyArc />}
        />

        <Route
          path="/conscient-parq-sector-80-gurugram"
          element={<ConscientParq />}
        />

        {/* <Route path="/sobha-altus-sector-106-gurgaon" element={<SobhaAltus/>} /> */}
        {/* <Route path="/sobha-city-sector-108-gurgaon" element={<SobhaCity/>} /> */}

        <Route
          path="/trinity-palazzos-sector-88b-gurugram"
          element={<TrinityPlazzos />}
        />

        <Route
          path="/whiteland-aspen-sector-76-gurugram"
          element={<WhiteLandTheAspen />}
        />
        <Route
          path="/urban-resort-sector-103-gurugram"
          element={<WhiteLandUrbanResort />}
        />

        <Route
          path="/dlf-privana-west-sector-76-gurugram"
          element={<DlfPrivanaWest />}
        />
        <Route
          path="/dlf-arbour-sector-63-gurugram"
          element={<DlfTheArbour />}
        />
        <Route
          path="/dlf-dahlias-sector-54-gurugram"
          element={<DlfDahlias />}
        />
        <Route
          path="/dlf-privana-south-sector-77-gurugram"
          element={<DlfPrivanaSouth />}
        />
        <Route
          path="/dlf-privana-north-sector-76-gurugram"
          element={<Privananorth />}
        />

        <Route path="/tarc-ishva-sector-63a-gurugram" element={<TarcIshva />} />
        <Route
          path="/birla-arika-sector-31-gurugram"
          element={<BirlaArika />}
        />
        <Route path="/experion-trillion" element={<Thetrillion />} />
        <Route path="/shapoorji-pallonji-dualis" element={<TheDualis />} />


        {/* <Route path="/eldeco-fairway-reserve" element={<EldecoFairwayReserve />} /> */}

        {/* Bengaluru Projects */}
        <Route
          path="/puravankara-purvabluebelle-rajajinagar-bengaluru"
          element={<PurvankaraBlubelle />}
        />
        <Route
          path="/puravankara-purva-meraki-hsr-layout-bengaluru"
          element={<PurvankaraMeraki />}
        />
        <Route
          path="/puravankara-purva-zenium-2-hosahalli-bengaluru"
          element={<PurvankaraZenium2 />}
        />
        <Route
          path="/puravankara-purva-park-hill-mallasandra-bengaluru"
          element={<PurvankaraParkHill />}
        />
        <Route
          path="/sattva-forest-ridge-jp-nagar-bengaluru"
          element={<SaatvaForestRidge />}
        />
        <Route
          path="/sattva-lumina-yelahanka-bengaluru"
          element={<SaatvaLumina />}
        />
        <Route
          path="/mantri-blossom-doddamavalli-bengaluru"
          element={<MantriBlossom />}
        />
        <Route
          path="/mantri-energia-hebbal-bengaluru"
          element={<MantriEnergia />}
        />
        <Route
          path="/brigade-insignia-yelahanka-bengaluru"
          element={<BrigadeInsignia />}
        />
        <Route
          path="/brigade-horizon-kumbalgodu-bengaluru"
          element={<BrigadeHorizon />}
        />
        <Route path="/tvs-emerald-cascadia" element={<Emeraldcascadia />} />
        <Route path="/tvs-isle-of-trees" element={<Isleoftrees />} />
        <Route path="/lodha-hosa-road" element={<Hosaroad />} />
        <Route path="/brigade-pashmina" element={<Pashmina />} />
        <Route path="/embassy-whitefield" element={<Whitefield />} />

        {/* Mumbai Projects */}
        <Route
          path="/kalpataru-vivant-andheri-east-mumbai"
          element={<Vivant />}
        />
        <Route
          path="/kalpataru-azuro-napeansea-road-mumbai"
          element={<KalpataruAzuro />}
        />
        <Route
          path="/kalpataru-advay-borivali-west-mumbai"
          element={<KalpataruAdvay />}
        />
        <Route
          path="/hiranandani-vista-residences-andheri-west-mumbai"
          element={<HiranandaniVista />}
        />
        <Route
          path="/hiranandani-regent-hill-powai-mumbai"
          element={<HiranandaniRegentHill />}
        />
        <Route path="/ekta-eden-62-juhu-mumbai" element={<EktaEden62 />} />
        <Route
          path="/ekta-parksville-phase-4-virar-west-mumbai"
          element={<EktaParksville />}
        />
        <Route
          path="/rustomjee-parishram-pali-hill-mumbai"
          element={<RustomjeeParishram />}
        />
        <Route
          path="/rustomjee-180-bayview-matunga-west-mumbai"
          element={<RustomjeeBayView />}
        />
        <Route
          path="/rustomjee-the-panorama-pali-hill-mumbai"
          element={<RustomjeePanorama />}
        />

        {/* Pune Projects */}
        <Route
          path="/godrej-evergreen-square-hinjewadi-pune"
          element={<EverGreenSquare />}
        />
        <Route
          path="/godrej-skygreens-kharadi-pune"
          element={<GodrejSkygreen />}
        />
        <Route
          path="/godrej-river-crest-kharadi-pune"
          element={<RiverCrest />}
        />
        <Route path="/godrej-skyline-mundhwa-pune" element={<Skyline />} />
        <Route path="/godrej-river-royale" element={<Riverroyale />} />
        <Route path="/gera-island-joy-kharadi-pune" element={<IslandOfJoy />} />
        <Route
          path="/gera-joy-tree-tops-hinjewadi-pune"
          element={<JoyOfTreetops />}
        />
        <Route
          path="/koltepatil-canvas-hinjewadi-pune"
          element={<KolteCanvas />}
        />
        <Route
          path="/lodha-giardino-kharadi-pune"
          element={<LodhaGiardino />}
        />

        <Route
          path="/codename-trendywest-tathawade-pune"
          element={<SaheelTrendyWest />}
        />
        <Route path="/ganga-serio" element={<Serio />} />

        {/* <Route path="/lodha-divino-matunga-mumbai" element={<LodhaDivino/>} /> */}
        <Route
          path="/shapoorji-pallonji-vanaha-bavdhan-pune"
          element={<ShapoorjiGolfland />}
        />
        <Route
          path="/wildernest-sp-kingston-shewalewadi-pune"
          element={<ShapoorjiWildernest />}
        />
        <Route
          path="/mantra-one-residences-magarpatta-pune"
          element={<MantraOneResidences />}
        />
        <Route
          path="/shapoorji-joyville-sensorium"
          element={<Joyvillesensorium />}
        />
        <Route path="/ganga-platinum" element={<Platinum />} />
        <Route path="/kalpataru-jade-skyline" element={<Jadeskyline />} />
        <Route path="/shubh-nirvana" element={<Shubhnirvana />} />
        <Route path="/unique-kville" element={<Uniquekville />} />
        <Route path="/rohan-saroha" element={<Saroha />} />
        <Route path="/bramha-skycity" element={<Skycity />} />
        <Route path="/nyati-evoque" element={<Evoque />} />
        <Route path="/godrej-emerald-waters" element={<Emeraldwaters />} />
        <Route path="/vjportia-grande" element={<Grande />} />
        <Route path="/lodha-panache" element={<Panache />} />
        <Route path="/rohan-nidita" element={<Nidita />} />
        <Route path="/lodha-magnus" element={<Magnus />} />
        <Route path="/kasturi-eon-homes" element={<Eonhomes />} />
        <Route path="/vtp-monarque" element={<Monarque />} />
        <Route path="/park-titan" element={<Parktitan />} />
        {/* <Route path="/megapolis-sunway" element={<Sunway />} /> */}
        <Route path="/itrend-homes" element={<Itrendhomes />} />
        <Route path="/ridges-41" element={<Ridges41 />} />
        <Route path="/rahul-aston" element={<Aston />} />


        {/* Location */}
        <Route path="/location/gurugram" element={<GurugramLocationPage />} />
        <Route path="/gurugram/spr-road" element={<SprRoad />} />
        <Route path="/gurugram/golf-course-road" element={<GolfCourseRoad />} />
        <Route
          path="/gurugram/dwarka-expressway"
          element={<DwarkaExpressway />}
        />
        <Route
          path="/gurugram/golf-course-extension-road"
          element={<GolfCourseExtensionRoad />}
        />

        <Route path="/location/pune" element={<PuneLocationPage />} />
        <Route path="/location/pune/west" element={<WestPune />} />
        <Route path="/location/pune/center" element={<CenterPune />} />
        <Route path="/location/pune/east" element={<EastPune />} />

        <Route path="/location/bengaluru" element={<BengaluruLocationPage />} />
        <Route path="/location/bengaluru/west" element={<WestBengaluru />} />

        <Route path="/location/mumbai" element={<MumbaiLocationPage />} />
        <Route path="/location/mumbai/east" element={<EastMumbai />} />
        <Route path="/location/mumbai/north" element={<NorthMumbai />} />
        <Route path="/location/mumbai/south" element={<SouthMumbai />} />

        <Route path="/dlf-the-arbour" element={<DlfTheArbour />} />
        <Route
          path="/whiteland-westin-residences"
          element={<WhiteLandUrbanResort />}
        />

        {/* News & Updates */}
        <Route path="/news-070125" element={<News_Update1 />} />
        <Route path="/news-080125" element={<News_Update2 />} />
        <Route path="/news-090125" element={<News_Update3 />} />

        <Route
          path="/real-estate-vs-mutual-fund-which-is-better-option"
          element={<Blog />}
        />
        <Route path="/pop-and-false-ceiling-design" element={<Blog210425 />} />
        <Route
          path="/interior-design-for-bedroom-and-living-room"
          element={<Blog240425 />}
        />

        <Route path="/blogs" element={<BlogList />} />
        <Route path="/blogs/:slug" element={<BlogDetailTwo />} /> 
      </Routes>
    </Router>
  );
  
}

export default App;
